import { mapGetters } from "vuex";

import moment from "moment";
const SectionTitle = () => import("../../SectionTitle.vue");
import notificationService from "../../../services/notification";
import {
  NotificationInAppStatus,
  StatusNotiInAppTagAction,
  TypeNotifications
} from "../../../constants/notification";

export default {
  components: {
    SectionTitle
  },

  data() {
    return {
      loading: true,
      isLoadMore: false,
      notifications: [],
      perPage: 5,
      fields: [
        {
          key: "dtStatus"
        }
      ],
      offset: 0,
      limit: null,
      notificationInterval: null,
      notificationList: [],
      visible: false,
      currentPage: 1,
      total: 0,
      pageSize: 10,
      richTextData: null,
      clickToCallData: null,
      externalLinkData: null,
      internalLinkData: null,
      oldNotificationList: []
    };
  },
  computed: {
    ...mapGetters("auth", {
      currentFrontendTech: "currentfrontendTech"
    }),
    ...mapGetters("notification", {
      notificationConfig: "notificationConfig"
    })
  },
  beforeDestroy() {
    clearInterval(this.notificationInterval);
  },
  destroyed() {
    clearInterval(this.notificationInterval);
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);

    if (
      this.notificationConfig &&
      this.notificationConfig.noNotificationsPerPage
    ) {
      this.limit = this.notificationConfig.noNotificationsPerPage;
    }
    let numberInterval;
    if (
      this.notificationConfig &&
      this.notificationConfig.noNotificationsPerPage
    ) {
      this.limit = this.notificationConfig.noNotificationsPerPage;
      numberInterval =
        this.notificationConfig &&
        this.notificationConfig.frequenceCallingListOfNotifications
          ? this.notificationConfig.frequenceCallingListOfNotifications * 1000
          : 30000;
    } else {
      if (localStorage.getItem("notificationConfig")) {
        this.limit = JSON.parse(
          localStorage.getItem("notificationConfig")
        ).noNotificationsPerPage;
        numberInterval =
          JSON.parse(localStorage.getItem("notificationConfig"))
            .frequenceCallingListOfNotifications * 1000;
        numberInterval = numberInterval ? numberInterval : 30000;
      } else {
        this.limit = 10;
        numberInterval = 30000;
      }
    }

    this.getNotificationList();
    this.notificationInterval = setInterval(() => {
      this.getNotificationList();
    }, numberInterval);
  },

  methods: {
    checkRichtextDisplayIcon(noti) {
      return noti.notificationDescLink;
    },
    updateDisplayStatus() {
      this.notificationList.map(item => {
        if (item.status == NotificationInAppStatus.RECEIVED) {
          const body = {
            idPkUserType: 2,
            pkUser: localStorage.getItem("pkClient"),
            keyFrontendTech: this.currentFrontendTech,
            idNotificationSentInAppList: [item.id],
            tagAction: StatusNotiInAppTagAction.DISPLAYED,
            typeNotification: TypeNotifications.IN_APP
          };

          notificationService.logUnreadNotification(body);
        }
      });
    },
    checkContentNotiLength(content) {
      if (content.length <= 100) {
        return true;
      }
      return false;
    },
    showModal() {
      this.$refs["richTextContent"].show();
    },
    closeModal() {
      this.$refs["richTextContent"].hide();
    },
    showNotiModal() {
      this.$refs["read-noti-modal"].show();
    },
    closeReadNotiPopup() {
      this.$refs["read-noti-modal"].hide();
    },
    readAllNoti() {
      this.logUnreadNoti({ item: { tagRead: false, id: "" } }, true);
      this.closeReadNotiPopup();
    },
    goToNotiDetail(noti) {
      this.loading = true;
      if (!noti.tagRead) {
        this.logUnreadNoti({ item: noti });
      }

      let notificationDescLinkObj = null;
      try {
        notificationDescLinkObj = JSON.parse(noti.notificationDescLink);
      } catch (err) {
        this.loading = false;
        if (
          noti.notificationDescLink &&
          typeof noti.notificationDescLink === "string"
        ) {
          this.openRichTextdetail(noti);
        }
      }
      if (
        notificationDescLinkObj &&
        notificationDescLinkObj.screenName !== "notification-richtext"
      ) {
        notificationDescLinkObj.props
          ? this.goToScreen(notificationDescLinkObj.screenName, {
              props: notificationDescLinkObj.props
            })
          : this.goToScreen(notificationDescLinkObj.screenName);
        this.loading = false;
        return;
      } else if (
        notificationDescLinkObj &&
        notificationDescLinkObj.screenName === "notification-richtext"
      ) {
        this.openRichTextdetail(noti);
      }
    },

    openRichTextdetail(noti) {
      const params = {
        id: noti.idNotificationRequest,
        params: {
          keyFrontendTech: this.currentFrontendTech,
          typeNotification: TypeNotifications.IN_APP
        }
      };
      this.getRichTextDetail(params);
    },
    getRichTextDetail(params) {
      notificationService
        .getRichTextDetail(params.id, params.params)
        .then(res => {
          this.richTextData = res;
          this.clickToCallData = null;
          this.externalLinkData = null;
          this.internalLinkData = null;
          if (
            this.richTextData &&
            this.richTextData.richTextClickToCall &&
            this.richTextData.richTextClickToCallLabel
          ) {
            this.clickToCallData = this.richTextData.richTextClickToCall
              ? {
                  numberPhone: this.richTextData.richTextClickToCall,
                  callLabel: this.richTextData.richTextClickToCallLabel
                }
              : null;
          }

          if (
            this.richTextData &&
            this.richTextData.richTextExternalLinkLabel &&
            this.richTextData.richTextExternalLink
          ) {
            this.externalLinkData = this.richTextData.richTextExternalLink
              ? {
                  label: this.richTextData.richTextExternalLinkLabel,
                  link: this.richTextData.richTextExternalLink
                }
              : null;
          }

          if (
            this.richTextData &&
            this.richTextData.richTextInternalLinkLabel &&
            this.richTextData.richTextDescLink
          ) {
            const richtextDeslink = JSON.parse(
              this.richTextData.richTextDescLink
            );
            this.internalLinkData = richtextDeslink.screenName
              ? {
                  screenName: richtextDeslink.screenName,
                  label: this.richTextData.richTextInternalLinkLabel
                    ? this.richTextData.richTextInternalLinkLabel
                    : null,
                  props: richtextDeslink.props
                    ? richtextDeslink.props
                    : undefined
                }
              : null;
          }

          this.richTextData = this.formatNotiContent(this.richTextData);

          this.loading = false;
          this.showModal();
        });
    },
    clickExternalLink() {
      if (
        !this.externalLinkData.link.includes("https://") &&
        this.externalLinkData.link.indexOf("www") >= 0
      ) {
        this.externalLinkData.link = "https://" + this.externalLinkData.link;
      }
      window.open(this.externalLinkData.link, "_blank");
    },
    clickInternalLink() {
      this.goToScreen(this.internalLinkData.screenName);
      this.closeModal();
    },
    goToScreen(screenName, props) {
      const link = this.$router.resolve({
        name: screenName
      });

      if (link.resolved.matched.length > 0) {
        if (props) {
          this.$router.push({
            name: screenName,
            params: props
          });
        } else {
          this.$router.push({
            name: screenName
          });
        }
      } else {
        this.callToaster(this.$t("internal-link-web-is-not-valid"));
      }
    },

    handleScroll() {
      if (
        window.innerHeight + window.pageYOffset >=
        document.body.offsetHeight - 50
      ) {
        this.loadPage();
      }
    },
    getNotificationList() {
      const param = {
        idPkUserType: 1,
        pkUser: localStorage.getItem("pkClient"),
        keyFrontendTech: this.currentFrontendTech,
        offset: this.offset,
        limit: this.limit
      };

      if (!this.currentFrontendTech) {
        notificationService.getFrontendTechs().then(result => {
          const currTokenOS = "Client";
          if (result) {
            this.oldNotificationList = [...this.notificationList];
            const webTech = result.frontendTechs.find(
              item =>
                item.tokenMethod &&
                item.tokenMethod.labelTokenMethod &&
                item.tokenMethod.labelTokenMethod === currTokenOS &&
                item.isWebApp
            ).key;
            this.$store.commit("auth/UPDATE_CURRENT_FRONTEND_TECH", webTech);

            param.keyFrontendTech = webTech;
            notificationService.getNotificationsInApp(param).then(res => {
              this.loading = false;
              this.notificationList = res.items;
              this.total = this.notificationList.length;
              this.updateDisplayStatus();
            });
          }
        });
      } else {
        this.oldNotificationList = [...this.notificationList];
        notificationService.getNotificationsInApp(param).then(res => {
          this.notificationList = res.items;
          this.loading = false;
          this.total = this.notificationList.length;
          this.updateDisplayStatus();
        });
      }
    },

    formatDateTime(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY  HH:mm");
      }
    },
    displayTime(index) {
      const date = new Date(this.notificationList[index].dtStatus).setHours(
        0,
        0,
        0,
        0
      );
      if (index === 0) {
        return this.getDisplayTime(date);
      } else {
        const dateBefore = new Date(
          this.notificationList[index - 1].dtStatus
        ).setHours(0, 0, 0, 0);
        if (
          dateBefore > date &&
          this.getMonth(dateBefore) !== this.getMonth(date)
        ) {
          return this.getDisplayTime(date);
        }
      }
    },

    getDisplayTime(time) {
      if (this.getMonth(time) == this.getMonth(new Date())) {
        return this.$t("notification-current-month");
      } else {
        return moment(time)
          .local()
          .format("MMMM YYYY");
      }
    },
    getSentTime(date) {
      return moment(date).format("LT");
    },
    getMonth(date) {
      return moment(date).month();
    },
    formatNotiContent(item) {
      var div = document.createElement("div");

      // assing your HTML to div's innerHTML
      div.innerHTML = item.richTextContent;
      // get all <a> elements from div
      let elements = div.getElementsByTagName("a");
      let arr = Array.prototype.slice.call(elements);
      if (arr.length > 0) {
        arr.map(ele => {
          if (ele.innerHTML && ele.innerHTML.includes("{pkCrf}")) {
            ele.href = ele.href.replace(
              "%7bpkCrf%7d",
              localStorage.getItem("pkClient")
            );
            ele.innerHTML = ele.href.replace(
              "{pkCrf}",
              JSON.parse(localStorage.getItem("pkClient"))
            );
          }
        });
      }
      item.richTextContent = div.innerHTML;
      return item;
    },
    logUnreadNoti(data, isReadAllNoti = false) {
      const body = {
        idPkUserType: 1,
        pkUser: localStorage.getItem("pkClient"),
        keyFrontendTech: this.currentFrontendTech,
        idNotificationSentInAppList: [data.item.id],
        isRead: !data.item.tagRead,
        tagAction: StatusNotiInAppTagAction.READ_OR_UNREAD,
        typeNotification: TypeNotifications.IN_APP
      };

      if (isReadAllNoti) {
        body.idNotificationSentInAppList = this.notificationList.map(item => {
          return item.id;
        });
        body.isRead = true;
      }

      notificationService
        .logUnreadNotification(body)
        .then(() => {
          if (isReadAllNoti) {
            this.notificationList = this.notificationList.map(item => {
              item.tagRead = true;
              return item;
            });
          } else {
            data.item.tagRead = !data.item.tagRead;
          }
        })
        .catch(err => {
          this.callToaster(err.message);
        });
    },
    loadPage() {
      const pageNotiSize =
        this.notificationConfig &&
        this.notificationConfig.noNotificationsPerPage
          ? this.notificationConfig.noNotificationsPerPage
          : this.pageSize;
      if (this.limit > this.total) {
        this.isLoadMore = false;
      } else {
        if (this.limit <= this.total && !this.isLoadMore && this.total > 0) {
          this.isLoadMore = true;
          setTimeout(() => {
            this.currentPage = this.currentPage + 1;
            this.limit = (this.currentPage - 1) * pageNotiSize + this.limit;
            this.getNotificationList();
            this.isLoadMore = false;
          }, 2000);
        }
      }
    }
  }
};
